import { ComponentProps } from "react";
import { BoldText } from "./BoldText";
import { Interpolation, Theme, css } from "@emotion/react";

export const SectionTitle = ({
  children,
  ...props
}: ComponentProps<typeof BoldText> & {
  css?: Interpolation<Theme>;
}) => {
  return (
    <BoldText
      tag="h2"
      css={css`
        display: flex;
        align-items: center;
      `}
      {...props}
    >
      {children}
    </BoldText>
  );
};
